var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEslint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2433,
    height: 2500,
    viewBox: "0 0 256 263",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.034 262.106L.598 172.57 28.45 41.694 155.626 .354l99.436 89.535-27.851 130.876-127.177 41.34zm-48.086-106.18l59.291 53.307 75.828-24.695 16.645-78.004-59.291-53.417-75.828 24.805-16.645 78.003z",
    fill: "#3A33D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.301 223.92H74.359l-53.525-92.69 53.525-92.69h106.942l53.525 92.69-53.525 92.69zM93.18 191.283h69.3l34.705-60.053-34.705-60.053h-69.3L58.584 131.23l34.596 60.053z",
    fill: "#6464E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEslint);
export default __webpack_public_path__ + "static/media/eslint.3190e29151b820e6cb8ab19561b63131.svg";
export { ForwardRef as ReactComponent };